/* eslint-disable no-unreachable */
import { Duck, createAction, createSelector, DuckSelector } from '@atc/modular-redux';
export default function formSubmissionDuckCreator(_temp) {
  let {
    namespace = '',
    store = 'formSubmission',
    storePath,
    initialState = {
      showConfirmation: false,
      serverError: ''
    },
    ...rest
  } = _temp === void 0 ? {} : _temp;
  return new Duck({
    ...rest,
    namespace,
    store,
    storePath,
    consts: {},
    types: ['SHOW_SUCCESS', 'SHOW_SERVER_ERROR', 'RESET'],
    initialState,
    reducer: (state, action, _ref) => {
      let {
        types
      } = _ref;
      switch (action.type) {
        case types.SHOW_SUCCESS:
          {
            return {
              ...state,
              showConfirmation: true
            };
            break;
          }
        case types.RESET:
          {
            return initialState;
            break;
          }
        case types.SHOW_SERVER_ERROR:
          {
            return {
              ...state,
              serverError: action.payload,
              showConfirmation: false
            };
            break;
          }
        default:
          return state;
      }
    },
    selectors: duck => ({
      getState: new DuckSelector(selectors => createSelector(selectors.getDuckState, localState => localState))
    }),
    creators: _ref2 => {
      let {
        types
      } = _ref2;
      return {
        showSuccess: createAction(types.SHOW_SUCCESS),
        showServerError: createAction(types.SHOW_SERVER_ERROR),
        reset: createAction(types.RESET)
      };
    }
  });
}